/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';
import { theme } from 'styles/theme/theme';

export type AnalyticsTone = 'gold' | 'green' | 'blue' | 'amber';

/** Цвет иконки и подложки — из темы; подложка добирается `color-mix` от него, а не своим hex8. */
export const TONE_COLORS: Record<AnalyticsTone, string> = {
  gold: theme.colors.DarkYellow,
  green: theme.colors.CaseSuccess,
  blue: theme.colors.Blue,
  amber: theme.colors.CasePending,
};

interface IconBadgeProps {
  icon: React.ReactNode;
  tone?: AnalyticsTone;
  /** Сторона квадрата, px. */
  size?: number;
}

const Badge = styled.div<{ $tone: string; $size: number }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: ${({ theme }) => theme.radii.card};
  color: ${({ $tone }) => $tone};
  background: color-mix(in srgb, ${({ $tone }) => $tone} 14%, transparent);
`;

/** Иконка на тонированной подложке: единый «значок» для карточек показателей и рекордов. */
const IconBadge = ({ icon, tone = 'gold', size = 44 }: IconBadgeProps) => (
  <Badge $tone={TONE_COLORS[tone]} $size={size} data-testid="icon-badge">
    {icon}
  </Badge>
);

export default IconBadge;
